<app-header></app-header>
<app-page-content></app-page-content>
<app-footer></app-footer>